import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Button from "../../ui/components/buttons/button";

import { useTranslation } from 'react-i18next';
import {_getSite, _getStep, _hideModal, _setStep, _showError, _showModal} from "../../store/system/service";

import "./quote-product.css";
import styled from "styled-components";
import typographyStyles from "../../ui/common/typography-styles";
import RadioBoxList from "../radio-box-list";
import PeopleOutline from "../../assets/PeopleOutline.svg";
import Call from "../../assets/Call.svg";
import Email from "../../assets/Email.svg";
import Template from "../template";
import {_getPolicy, _ratePolicy, _storePolicy} from "../../store/policy/service";
import {_searchAddress} from "../../store/addresses/service";
import {withRouter} from "react-router";
import IconAlert from '../../ui/components/icons/legacy/alert';
import {_gaPushEvent, _gaPushData} from '../../utils/utility'
import ErrorMessage from "../error-message";

const options = [
    {
        value: '785405',
        text: 'Office',
        dateRange: 'As low as S$302.82',
        occupationDesc: 'Office',
        businessType: 'Office'
    },
    {
        value: '511010',
        text: 'Retail Shop',
        dateRange: 'As low as S355.64',
        occupationDesc: 'General retail store',
        businessType: 'General retail store'
    },
    {
        value: '511035',
        text: 'Groceries Store',
        dateRange: 'As low as S$365.42',
        occupationDesc: 'Groceries store',
        businessType: 'Groceries store'
    },
    {
        value: '0',
        text: 'Others',
        dateRange: '\xa0',
        occupationDesc: 'Others',
        businessType: 'Others'
    }
]

const Description = styled.div`
    ${typographyStyles({
    type: 'text',
    defaultSize: 'normal',
    defaultWeight: 'semiBold',
})}
`;

const DateRange = styled.div`
    ${typographyStyles({
    type: 'text',
    defaultSize: 'small',
    defaultWeight: 'normal',
})}
`;

const QuoteProduct = (props) => {
    const [product, setProduct] = useState(props.product);
    const [toggleAlert, setToggleAlert] = useState(false);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
        // Google Analytics
        _gaPushData({
            'pageStep': 'Quote – Business Type',
            'vPath': '/quote-business-type',
            'event': 'vpageview',
        });
    }, [])

    const selectProduct = (product) => {
        console.log('select product ' + product);

        if (product === '0') {
            _gaPushEvent('BusinessTypeOthers');
            _gaPushData({
                'pageStep': 'OthersContactUs',
                'vPath': '/otherscontactus',
                'event': 'vpageview'
            });
            if (props.site === 'bm') {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Brian Mae     Insurance Broker',
                        content:
                            <div  className="QuoteContent">
                                Brian Mae Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone"/> +65 6224 6633 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> SME@brianmae.com
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: () => {
                                _gaPushEvent('viewclosecontactuslater');
                                props.hideModal();
                            }
                        }
                    }
                )
            }
            else if(props.site === 'mla'){
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Multi-Lines Agencies       Insurance Agency',
                        content:
                            <div className="QuoteContent MLA">
                                Multi-Lines Agencies
                                <br/>
                                <div className={'mla-popup'} >
                                    <img src={Call} className="QuoteSizePhone" style={{'margin-right':'3px'}}/>
                                    + 65 9820 4276 / <br className={'mobileOnlyBr'}/>8499&nbsp;0385&nbsp;/&nbsp;9171&nbsp;1477
                                </div>                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> info@multilines.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: () => {
                                _gaPushEvent('viewclosecontactuslater');
                                props.hideModal();
                            }
                        }
                    }
                )
            }
            else {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our g&m      Insurance Broker',
                        content:
                            <div  className="QuoteContent">
                                g&m Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone" /> +65 6576 9855 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> corporate@gnm.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: () => {
                                _gaPushEvent('viewclosecontactuslater');
                                props.hideModal();
                            }
                        }
                    }
                )
            }
        }
         
        setProduct(product);
        setToggleAlert(false);
        //setToggleAlert(false);
        // this is a test for http call to b2c-server
        // props.searchAddress('123').then( resp => {
        //         console.log(resp);
        // })

        // props.ratePolicy({}).then ( resp => {
        //         console.log(resp);
        // })
        //props.showError(['this is error message', 'this is the second error message']);
    }

    const emailUs = () => {
        _gaPushEvent('viewcloseemail');
        if (props.site === 'bm') {
            window.location = "mailto:SME@brianmae.com";
        }
        else if(props.site === 'mla'){
            window.location = "mailto:info@multilines.com.sg"
        }
        else {
            window.location = "mailto:corporate@gnm.com.sg";
        }
    }

    const continueNextPage = () => {
        if (!product) {
            setToggleAlert(true);
            //props.showError(['Please select a product type']);
        }
        // Others
        else if (product === '0') {
            _gaPushData({
                'pageStep': 'OthersContinueContactUs',
                'vPath': '/otherscontinuecontactus',
                'event': 'vpageview'
            });
            if (props.site === 'bm') {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Brian Mae      Insurance Broker',
                        content:
                            <div className="QuoteContent">
                                Brian Mae Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone"/> +65 6224 6633 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> SME@brianmae.com
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: () => {
                                _gaPushEvent('viewclosecontactuslater');
                                props.hideModal();
                            }
                        }
                    }
                )
            }
            else if(props.site === 'mla'){
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Multi-Lines Agencies       Insurance Agency',
                        content:
                            <div className="QuoteContent  MLA">
                                Multi-Lines Agencies
                                <br/>
                                <div className={'mla-popup'} >
                                    <img src={Call} className="QuoteSizePhone" style={{'margin-right':'3px'}}/>
                                    + 65 9820 4276 / <br className={'mobileOnlyBr'}/>8499&nbsp;0385&nbsp;/&nbsp;9171&nbsp;1477
                                </div>                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> info@multilines.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: () => {
                                _gaPushEvent('viewclosecontactuslater');
                                props.hideModal();
                            }
                        }
                    }
                )
            }
            else {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our g&m      Insurance Broker',
                        content:
                            <div className="QuoteContent">
                                g&m Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone"/> +65 6576 9855 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> corporate@gnm.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: () => {
                                _gaPushEvent('viewclosecontactuslater');
                                props.hideModal();
                            }
                        }
                    }
                )
            }
            return;
        }
        else {
            const selectedProducts = options.filter((item) => item.value === product);

            if (selectedProducts.length > 0 && props.policy) {
                props.policy.policySME.occupationCode = selectedProducts[0].value;
                props.policy.policySME.occupationDesc = selectedProducts[0].occupationDesc;
                props.policy.policySME.businessType = selectedProducts[0].businessType;
                if (selectedProducts[0].value === '785405') {
                    props.policy.policySME.officePack = true;
                    props.policy.policySME.shopPack = false;
                } else {
                    props.policy.policySME.officePack = false;
                    props.policy.policySME.shopPack = true;
                }

                props.storePolicy(props.policy);
            }

            props.history.push((props.site ? '/' + props.site : '') + '/quote/review');
        }
    }

    return (
        <Template simple="Quotation" step={props.step} policy={props.policy} site={props.site} prevPage="/quote/size">
                <div className="QuoteItemsTitleGroupStyle">
                    <div className="QuoteItemsTitleStyle">Which of the below applies to your business?</div>
                </div>
                <div className="QuoteItemsGroupStyle">
                    <RadioBoxList
                        options={options}
                        value={product}
                        onClick={selectProduct}
                    />
                </div>
                {!!toggleAlert && (
                    <ErrorMessage>
                        Please select a product type.
                    </ErrorMessage>
                )}
                <div className="QuoteItemBtnGroupStyle">
                    <Button color="primary" onClick={continueNextPage}>Continue</Button>
                </div>
        </Template>
    );

}


// get status from redux (subscription)
const mapStateToProps = (state) => {
    const currPolicy = _getPolicy(state);

    let selectedProduct = '';
    if (currPolicy && currPolicy.policySME.businessType) {
        let products = options.filter((item) => item.value === currPolicy.policySME.occupationCode);
        if (products.length > 0) {
            selectedProduct = products[0].value;
        }
    }

    return {
        policy: currPolicy,
        product: selectedProduct,
        step: _getStep(state),
        site: _getSite(state)
    }
}

// send service request to redux
const mapDispatchToProps = {
    storePolicy: _storePolicy,
    searchAddress: _searchAddress,
    ratePolicy: _ratePolicy,
    showError: _showError,
    setStep: _setStep,
    showModal: _showModal,
    hideModal: _hideModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuoteProduct));


